import { API_BASE_URL, motogoFetch } from './api';

/**
 * Wire shape of GET/PUT /me/settings. Known keys are typed; any other keys are settings
 * a newer client wrote — keep them and send them back on save so they survive a
 * round-trip through this (older) client. The server clamps known keys into range and
 * returns the saved result.
 */
export interface ServerSettings {
  zoomOffset?: number | null;
  speedZoom?: boolean | null;
  showPeers?: boolean | null;
  lockNorth?: boolean | null;
  speedUnit?: string | null;
  routeMode?: string | null;
  routeGravel?: string | null;
  routeRoundTrip?: boolean | null;
  routeDistanceKm?: number | null;
  autoRecord?: boolean | null;
  rideSplitGapMin?: number | null;
  [key: string]: unknown;
}

/** Fetches the signed-in user's synced settings. Returns null on 401 (no/stale session). */
export async function fetchServerSettings(): Promise<ServerSettings | null> {
  const res = await motogoFetch(`${API_BASE_URL}/me/settings`);
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(`GET /me/settings failed: ${res.status}`);
  return (await res.json()) as ServerSettings;
}

/** Replaces the synced settings server-side. Returns the saved result, or null on 401. */
export async function saveServerSettings(settings: ServerSettings): Promise<ServerSettings | null> {
  const res = await motogoFetch(`${API_BASE_URL}/me/settings`, {
    method: 'PUT',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(settings),
  });
  if (res.status === 401) return null;
  if (!res.ok) throw new Error(`PUT /me/settings failed: ${res.status}`);
  return (await res.json()) as ServerSettings;
}
